import React from 'react'
import './style.css'
import Button from '../CtaButton'

const NewRoadMap = ({ roadmapContent }) => {
    return (
        <>
            <section className="new-roadmap-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-md-12">
                            <div className="new-roadmap-section-text">
                                <h2 className="why-us-short-heading-text">{roadmapContent?.shortHeading}</h2>
                                <p
                                    className="new-roadmap-main-heading"
                                    dangerouslySetInnerHTML={{ __html: roadmapContent?.heading }}
                                ></p>
                                <p className="description-text">{roadmapContent?.description}</p>
                            </div>
                        </div>
                    </div>

                    <div className="row new-roadmap-row">
                        <div className="col-lg-4 col-md-12 new-roadmap-left-col">
                            <div className="new-roadmap-reps-card">
                                <div className="new-roadmap-reps-images">
                                    <img src="/images/life-at-bitsclan/dusty.avif" alt="Team member 1" className="new-roadmap-rep-img new-roadmap-rep-img-1" />
                                    <img src="/images/life-at-bitsclan/omoniyi.avif" alt="Team member 3" className="new-roadmap-rep-img new-roadmap-rep-img-3" />
                                    <img src="/images/life-at-bitsclan/aamanda.avif" alt="Team member 2" className="new-roadmap-rep-img new-roadmap-rep-img-2" />
                                </div>
                                <h4 className="new-roadmap-reps-title">We have reps across the US.</h4>
                                <p className="new-roadmap-reps-text">
                                    Speak with a client engagement specialist near you.
                                </p>

                                <Button styles={{ width: '80%', }} newTab text={roadmapContent?.cta?.text} link={roadmapContent?.cta?.link} />
                            </div>
                        </div>

                        <div className="col-lg-8 col-md-12 new-roadmap-right-col">
                            <div className="new-roadmap-steps-container">
                                {roadmapContent?.processData?.map((list, index) => {
                                    return <div className="new-roadmap-step" key={index}>
                                        <div className="new-roadmap-icon-container">
                                            <img className='new-roadmap-icon' src={`${list?.icon || "/images/roadmap-icons/platform-evaluation.svg"}`} alt="" />
                                        </div>
                                        <div className="new-roadmap-content">
                                            <h3 className="new-roadmap-step-title">{list?.title}</h3>
                                            <p className="new-roadmap-step-text">{list?.description}</p>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default NewRoadMap